





































import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'

const titleModule = getModule(TitleModule)

@Component
export default class TheNavbar extends Vue {
  get pageTitle() {
    return titleModule.pageTitle
  }

  get addButton() {
    if (
      this.$route.matched.some(
        record =>
          record.name === 'home' ||
          record.name === 'extensions' ||
          record.name === 'witness-interviews' ||
          record.name === 'stage-admin' ||
          record.name === 'stage-info-admin' ||
          record.name === 'prompts-admin' ||
          record.name === 'companies'
      )
    ) {
      return true
    } else {
      return false
    }
  }
}
